export enum SystemPropertyKey {
  treasuryApprovalContacts = 'default.treasuryApprovalContacts',
  creditFacilities = 'default.creditFacilities',
  valuationAttachmentTypes = 'default.valuation.AttachmentTypes',
  valuationSignatoriesList = 'default.valuation.signatoriesList',
  reviewAttachmentTypes = 'default.review.AttachmentTypes',
  executionQuarter = 'default.executionQuarter',
  boardMeetingAttachmentTypes = 'default.boardMeeting.AttachmentTypes',
  valuationsummaryQuarters = 'default.valuationsummary.quarters',
  reviewBudgetSummaryNoShowPcList = 'default.review.budgetSummaryNoShowPcList',
  logoAttachmentTypes = 'default.logo.attachmentTypes',
  commitmentoverviewStartquarter = 'default.commitmentoverview.startquarter',
  tearsheetCurrentQuarter = 'default.tearsheet.currentQuarter',
  capitalCallEquityCallAttachmentTypes = 'default.capitalCall.EquityCall.AttachmentTypes',
  portfolioReviewQuarters = 'default.portfolioReview.quarters',
  notificationsAssignedUserList = 'default.notifications.assignedUserList',
  tearsheetpackageQuarters = 'default.tearsheetpackage.quarters',
  viewAllPcStatusGroup = 'default.viewAllPcStatusGroup',
  tearsheetTextSectionLimits = 'default.tearsheet.textSectionLimits',
  featureFlags = 'default.featureFlags',
  configs = 'default.configs',
  powerbi = 'default.powerbi',
  capitalCallBridgeLoanAttachmentTypes = 'default.capitalCall.BridgeLoan.AttachmentTypes',
  capitalCallLetterOfCreditAttachmentTypes = 'default.capitalCall.LetterOfCredit.AttachmentTypes',
  distributionAttachmentTypes = 'default.distribution.AttachmentTypes',
  commitmentAttachmentTypes = 'default.commitment.AttachmentTypes',
  commitmentSignatories = 'default.commitment.signatories',
  portfolioCompanyMasterList = 'default.portfolioCompanyMasterList',
  valuationSignatoriesExcludeList = 'default.valuation.signatoriesExcludeList',
  eventsNotification = 'default.events.Notification',
  fundReport = 'default.fundReport',
  fundSplitIRR = 'default.fundSplit.IRR',
  shadowPcConfig = 'default.shadowPcConfig',
  pcAnalyticsLiveQuarters = 'default.pcAnalytics.liveQuarters',
  pcAnalyticsCompanies = 'default.pcAnalytics.companies',
  pcAnalyticsFunds = 'default.pcAnalytics.funds',
}